<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" width="55%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="mini">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="报价轮次" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="roundNo" style="margin-bottom: 0;">
                        {{dataForm.roundNo}}
                        <!-- <el-input v-if="viewFlag !== 'view'" v-model="dataForm.roundNo"></el-input>
                        <span v-else>{{dataForm.roundNo}}</span> -->
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <el-input v-show="isShow" v-model="dataForm.id" placeholder="ID" readonly></el-input>
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.partCode" maxlength="100"></el-input>
                        <span v-else>{{dataForm.partCode}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.partName" maxlength="200"></el-input>
                        <span v-else>{{dataForm.partName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="原材料" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rawMaterial" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.rawMaterial" maxlength="200"></el-input>
                        <span v-else>{{dataForm.rawMaterial}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="原材料价格(元)" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="priceCost" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.priceCost" maxlength="200"></ctl-number>
                        <span v-else>{{dataForm.priceCost}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="投入重量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="weight" style="margin-bottom: 0;">
                        <ctl-number :precision="4" :p="4" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.weight" maxlength="200"></ctl-number>
                        <span v-else>{{dataForm.weight}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="废料价格" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="wasteCost" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.wasteCost" maxlength="200"></ctl-number>
                        <span v-else>{{dataForm.wasteCost}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="废料重量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="wasteWeight" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.wasteWeight" maxlength="200"></ctl-number>
                        <span v-else>{{dataForm.wasteWeight}}</span>
                    </el-form-item>
                </el-descriptions-item>
              <el-descriptions-item label="供应商" :label-style="getStyle()" :content-style="getStyle2()">
                <el-form-item prop="supplierName" style="margin-bottom: 0;">
                  <el-input v-if="viewFlag !== 'view'" v-model="dataForm.supplierName" maxlength="100"></el-input>
                  <span v-else>{{dataForm.supplierName}}</span>
                </el-form-item>
              </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="small" type="primary" v-if="viewFlag != 'view'" plain @click="dataFormSubmit()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    getQuotationMateralById,
    quotationMateralInsert,
    quotationMateralUpdate,
    getRfqBaseById
} from "@/controller/quotation";
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            isShow: false,
            viewFlag: '',
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewData: {},
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                partCode: '',
                partName: '',
                rawMaterial: '',
                priceCost: 0,
                weight: 0,
                wasteCost: 0,
                wasteWeight: 0,
                roundNo: 0
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    methods: {
        // 初始化
        init(id, viewFlag, data, rfqId) {
            this.view.visible = true;
            this.viewFlag = viewFlag
            mapping(data, this.dataForm)
            this.dataForm.id = id || 0;
            this.dataForm.rfqId = rfqId
            this.$nextTick(() => {
                // this.$refs["dataForm"]={};
                this.$refs['dataForm'].resetFields()
                if (id) {
                    // 根据id查汇率
                    getQuotationMateralById({}, id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    getRfqBaseById({}, this.dataForm.rfqId).then(data => {
                        if (data && data.code === '00') {
                            //console.log('data.body.rfqStatus===========',data.body.rfqStatus)
                            if("2" != data.body.rfqStatus) {
                                this.$message.warning("询价单不是询价中状态，不允许修改报价相关信息")
                            } else {
                                if (this.dataForm.id) {
                                    // 更新汇率表
                                    quotationMateralUpdate(this.dataForm)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit("refreshMateralDataList");
                                                        this.$emit("getDataListAll");
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                } else {
                                    // 创建汇率表
                                    quotationMateralInsert(this.dataForm)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit("refreshMateralDataList");
                                                        this.$emit("getDataListAll");
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            }
                        }
                    })
                }
            });
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            // return 'width: 647.5px;'
        }
    },
};
</script>
